import { render, staticRenderFns } from "./TokenPassword.vue?vue&type=template&id=3086d9c6&"
import script from "./TokenPassword.vue?vue&type=script&lang=js&"
export * from "./TokenPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports